var lists_default = {
  "fontElementMap": "_3hkYz",
  "orderedlist": "_5dPcQ",
  "bulletedlist": "RcCw-",
  "listItem": "vOjuI"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
